<template>
  <v-container fluid grid-list-xl pa-0 ma-0>
    <ValidationObserver ref="observer" slim v-slot="{ invalid, validate }">

      <form ref="form" @submit.prevent="recuperarSenha(validate)">
        <v-layout row wrap pa-0 ma-0>

          <v-alert type="info" :value="!!emailEnviadoLinkRecuperacao" transition="zoomUp" icon="fa-info-circle"
            class="subheading" style="animation-duration: 0.5s;" outline>
            {{ $t('msg_enviou_link_recuperacao_email', { email: emailEnviadoLinkRecuperacao }) }}
          </v-alert>

          <v-flex xs12>
            <v-label>{{ $t('msg_informe_seu_email') }}</v-label>
          </v-flex>

          <v-flex xs12>
            <ValidationProvider name="recuperar_senha_email" rules="required|email" v-slot="{ errors }">
              <v-tooltip bottom>
                <v-text-field slot="activator" type="email" name="email" :label="$t('email')" v-model="email"
                  :error-messages="errors" />
                {{ $t('tooltips.email') }}
              </v-tooltip>
            </ValidationProvider>
          </v-flex>

          <v-flex xs12 pa-0 ma-0>
            <v-layout wrap pa-0 ma-0 v-bind="{ ...($vuetify.breakpoint.mdAndDown ?
                { column: true, reverse: true } : { row: true }) }">
              <v-flex xs12 sm12 md6 align-self-center font-family-poppins>
                <router-link to="/autenticacao/entrar">
                  {{ $t('cancelar_recuperar_senha') }}
                </router-link>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-btn type="submit" block round color="primary" class="font-weight-bold" :disabled="invalid">
                  {{ $t('confirmar') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>
      </form>

    </ValidationObserver>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import formatApiError from '@/utils/helpers/errors/formatApiError'
import focusOnFirstError from '@/utils/helpers/validations/focusOnFirstError'

const { mapActions } = createNamespacedHelpers('login')
const { mapState } = createNamespacedHelpers('cliente')

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      email: undefined,
      emailEnviadoLinkRecuperacao: undefined
    }
  },
  computed: {
    ...mapState(['idCliente'])
  },
  methods: {
    ...mapActions(['esquecerSenha']),
    async recuperarSenha (validate) {
      if (await validate()) {
        this.esquecerSenha({
          idCliente: this.idCliente,
          email: this.email
        }).then((response) => {
          this.emailEnviadoLinkRecuperacao = this.email
          this.email = undefined
        }).catch((error) => {
          this.$snotify.error(formatApiError(error))
        })
      } else {
        focusOnFirstError(this.$refs.observer)
      }
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "email": "E-mail",
    "confirmar": "Confirmar",
    "cancelar_recuperar_senha": "Lembrei a senha",
    "msg_informe_seu_email": "Informe o seu e-mail e clique em confirmar para receber o link de recuperação da senha.",
    "msg_enviou_link_recuperacao_email": "Enviamos um link com a recuperação da sua senha para o e-mail: {email}",
    "tooltips": {
      "email" : "Informe o seu e-mail."
    }
  }
}
</i18n>
